import { useState } from 'react';
import { Outlet, Link, NavLink, useLocation } from 'react-router-dom';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Menu, theme, Button, Breadcrumb, Radio, Table, Divider, Spin } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { useEffect } from 'react';
import pingService from '../services/ping';
import {cleanToken} from '../authorization/auth'

import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    UploadOutlined,
    FileDoneOutlined,
    ProfileOutlined,
    FileImageOutlined,
    FileZipOutlined,
    UserOutlined,
    VideoCameraOutlined,
    CarOutlined,
} from '@ant-design/icons';
import {
    AppstoreOutlined,
    BarChartOutlined,
    CloudOutlined,
    ShopOutlined,
    TeamOutlined
} from '@ant-design/icons';

import { Footer } from 'antd/es/layout/layout';

import './AppLayout.css'

const { Header, Content } = Layout;
const items = [
    {a: FileDoneOutlined, b:'Сайт', k: '/pages', children: [
        {a: FileDoneOutlined, b:'Страницы', k: '/pages'},
        {a: ProfileOutlined, b:'Категории', k: '/categories'},
        {a: FileZipOutlined, b:'Продукты', k: '/products'},
        {a: FileImageOutlined, b:'Атрибуты', k: '/attributes'},
        {a: AppstoreOutlined, b:'Ссылки', k: '/sefurls'},
    ]},
    {a: AppstoreOutlined, b:'Виджеты', k: '/widgets'},
    {a: CarOutlined, b:'Шаблоны', k: '/templates'},
    {a: ProfileOutlined, b:'Галереи', k: '/galleries'},
    {a: TeamOutlined, b:'Пользователи', k: '/users', children: [
        { a: TeamOutlined, b: 'Пользователи', k: '/users' },
        { a: AppstoreOutlined, b: 'Группы', k: '/users/groups' },
    ]},
  ].map((icon, index) => ({
    key: icon.k,
    icon: React.createElement(icon.a),
    label: icon.b,
    children: icon.children ? icon.children.map(child => ({
        key: child.k,
        icon: React.createElement(child.a),
        label: child.b
    })) : []
}));

const Logo = (collapsed) => {
    return (
        <Link to="/">
            <img 
                src="" 
                style={{
                    float: 'left',
                    lineHeight: .8,
                    marginLeft: 0.8,
                    marginRight: 0.5,
                    marginTop: -3,
                    maxHeight: 33,
                    width: 'auto'
                }}
            />
            <span className="logotext"
                style={{
                    display: collapsed.collapsed === false ? 'inline' : 'none'
                }}
            >OpenGoCart</span>
        </Link>
    )
}

const AppLayout = () => {
    const navigate = useNavigate()
    const [collapsed, setCollapsed] = useState(false);
    const [showPreloader, setShowPreloader] = useState(true);

    useEffect(() => {
        pingService.ping()
        .then(response => {
            if (response.status === 200) {
                setShowPreloader(false)
            }
        })
        .catch(e => {
            cleanToken()
            navigate('/login/')
        });
    }, []);

    return (
        <Layout className="app-layout">
            <Sider
                className="app-layout-slider"
                collapsed={collapsed}
                onCollapse={(value) => setCollapsed(value)}
                width={250}
            >
                <div className="app-layout-logo">
                    <Logo collapsed={collapsed}/>
                </div>

                <Menu
                    className="app-layout-menu"
                    theme="dark"
                    mode="inline"
                    style={{ height: '100%', borderRight: 0 }}
                    onClick={(e) => {navigate(e.key)}}
                >
                {items.map(item => (
                    item.children.length > 0 ? (
                    <Menu.SubMenu                  
                        key={item.key} icon={item.icon} title={item.label}>
                        {item.children.map(subItem => (
                        <Menu.Item 
                            key={subItem.key} icon={subItem.icon}>
                            {subItem.label}
                        </Menu.Item>
                        ))}
                    </Menu.SubMenu>
                    ) : (
                    <Menu.Item 
                        key={item.key} icon={item.icon}>
                        {item.label}
                    </Menu.Item>
                    )
                ))}
                </Menu>
            </Sider>
            <Layout>
                <Header className="app-layout-header">
                    <Button
                        className="buter"
                        type="text"
                        icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                        onClick={() => setCollapsed(!collapsed)}
                        style={{ fontSize: '16px' }}
                    />
                    <a class="exitlink" href="/logout">Выход</a>
                </Header>
                <Content>
                    <div className="app-layout-content-box">
                        <Outlet/>
                    </div>
                </Content>
                <Footer className="app-layout-footer">
                    Version 0.1.1
                </Footer>
            </Layout>
        </Layout>
    )
}

export default AppLayout;
